import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserRegistrationService } from './services/user-registration.service';
import { ConfigService } from '../../services/config.service';

declare global {
    interface Window {
        dataLayer: any;
    }
}

@Component({
    selector: 'app-self-service',
    templateUrl: './self-service.component.html',
    styleUrls: ['./self-service.component.scss'],
})
export class SelfServiceComponent implements OnInit {
    @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;

    constructor(
        private router: Router,
        private userRegistrationService: UserRegistrationService,
        private translateService: TranslateService,
        private titleService: Title,
        private configService: ConfigService
    ) {}

    ngOnInit() {
        this.translateService.get('SELF_SERVICE.META.DOCUMENT_TITLE').subscribe((title) => {
            this.titleService.setTitle(title);
        });
        if (!this.configService.isEmployee() && !!this.configService.getIdentityType()) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                user_id: this.configService.me.id,
                event: 'login',
            });
        }
    }

    toggleSidenav() {
        this.sidenav.toggle();
    }
}
